var exports = {
  "b": "feedbackLinkWrapper__h2wARm",
};

module.exports = exports;
